import { api } from '@/services/api/main/axios';

export interface TwoFactorForm {
  token: string;
  trust: boolean;
}

export interface TwoFactorPayload {
  result: boolean;
  backupCodeUsed?: boolean;
}

export const twoFactorApiRequest = async (form: TwoFactorForm): Promise<TwoFactorPayload> => {
  const res = await api.post('auth/two-factor', form);
  return res.data.payload;
};
